export default {"src":"/_next/static/media/insurance.a64484cd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};